import { secondsFromMidnightToHumanTime } from '@e3dc-react/shell/Libs/date'
import { IdlePeriodSettingsFormModel, IdlePeriodSettingsModel } from 'src/Libs/smart-charge/models'
import { EmsIdlePeriodFormField, EmsPeriod } from 'src/Libs/smart-charge/types'

const idlePeriodModelToForm = (values: EmsPeriod[]): EmsIdlePeriodFormField[] => {
  return values.map((idlePeriodTime, index) => ({
    daysOfWeek: idlePeriodTime.weekdays,
    type: idlePeriodTime.peridodType,
    startTimeOfDay: secondsFromMidnightToHumanTime(idlePeriodTime.start),
    endTimeOfDay: secondsFromMidnightToHumanTime(idlePeriodTime.stop),
    description: idlePeriodTime.name,
    isActive: idlePeriodTime.isActive,
  }))
}

const modelToSettingsFormTransformer = (model: IdlePeriodSettingsModel): IdlePeriodSettingsFormModel => ({
  emsGetIdlePeriodsEnable: model.emsGetIdlePeriodsEnable,
  emsIdlePeriod: idlePeriodModelToForm(model.emsIdlePeriod),
})
export default modelToSettingsFormTransformer
